<app-detail [name]="name"
            [id]="id"
            [apiController]="apiController"
            [views]="views"
            viewType="compressed"
            (entityLoaded)="entityLoaded()"
            [(entity)]="entity"
            [removeDefaultToolbarItems]="removeDefaultToolbarItems"
            [showSaveButton]="showSaveButton"
            [showRemoveButton]="showRemoveButton"
            [toolbarItems]="toolbarItems"
            [keyFieldName]="keyFieldName"
            [preSave]="true"
            (save)="preSave($event)">

</app-detail>

<div class="wrapper">
  <kendo-expansionpanel *ngFor="let securityRoleDescription of securityRoleDescriptions; index as i"
                        [title]="securityRoleDescription.name"
                        [expanded]="false">
    <div class="content">
      <span class="content-text">{{ securityRoleDescription.description }}</span>
    </div>
  </kendo-expansionpanel>
</div>
